const d3 = require("d3");
const { getCumulativeWaitingTimesPerGroup } = require("@/visualisation/graphs/waitingTimeAnimations/waitingTimeMath.js");

class NodeVisualiser {
  constructor(resourceGroups) {
    this.resourceGroups = resourceGroups;
  }

  createResourceGroupNodes(graphParentGroup, positions) {
    var idToResource = this.getIDResourceToGroupMap(positions);

    var resourceNodeGroups = this.createResourceNodeGroups(Object.values(idToResource), graphParentGroup);

    var resourceNodes = this.createResourceNodes(resourceNodeGroups, idToResource);

    this.nodes = resourceNodes.nodes;
    this.notificationNodes = resourceNodes.notificationNodes;
    
    var textLabels = this.createTextLabels(resourceNodeGroups);
  }

  // Create parent groups for each resource group node
  createResourceNodeGroups(nodePositions, graphParentGroup) {
    var resourceNodeGroups = graphParentGroup
      .selectAll("nodes")
      .data(nodePositions)
      .enter()
      .append("g")
      .attr("transform", function (d, i) {
        return "translate(" + d.x + "," + d.y + ")";
      });

    return resourceNodeGroups;
  }

  // Create the resource nodes
  createResourceNodes(resourceNodeGroups, idToResource) {

    var notificationSize = 0; // Your stroke width
    var originalRadius = 40; // Your original radius
    
    var resourceNodes = resourceNodeGroups
    .append("circle")
    .attr("id", (_, index) => {
      return `circle-${index}`;
    })
    .attr("r", originalRadius)
    .style("opacity", 1)
    .style("stroke-width", 2)
    .style("stroke-opacity", 1)
    .style("stroke", "#57504d")
    .style("fill", (d) => {
      return idToResource[d.id].color;
    });
    
    var notificationNodes = resourceNodeGroups
      .append("circle")
      .attr("r", notificationSize)
      .style("fill", "#60D937")
      .style("stroke-width", 1)
      .style("stroke-opacity", 1)
      .style("opacity", 0.8)
      .style("stroke", "#57504d")
      .attr("transform", "translate(-35,-35) scale(1)")
    
    return {nodes: resourceNodes, notificationNodes: notificationNodes};
  }

  createTextLabels(resourceNodeGroups) {
    var textLabels = resourceNodeGroups
      .append("text")
      .attr("text-anchor", "middle")
      .attr("dy", ".08em")
      .attr("dx", "0em")
      .attr("vector-effect", "non-scaling-stroke")

      .attr("dominant-baseline", "middle")
      .attr("font-size", "35px")
      .attr("style", "fill: #F0F0F0;")
      .text(function (d) {
        return d.id;
      });

      return;

    var textNodes = {};

    var dx = {"I": 12, "A": 18, "B": 15, "M": 21, "G": 17, "O": 17, "P": 16};

    var capacityLabels = resourceNodeGroups
      .append("text")
      .attr("text-anchor", "middle")
      .attr("font-size", function (d) {
        textNodes[d.id] = this;
        if (d.id == "G") {
          return 20;
        }
        return 15;
      })
      .attr("dy", "1em")
      .attr("dx", function (d) {
        return dx[d.id] - 2;
      })
      .attr("vector-effect", "non-scaling-stroke")
      .attr("style", "fill: #F0F0F0;")
      .text(function (d) {
        if (d.id == "G") {
          return "∞";
        }
        return 1;
        return metrics.currCapacities[d.id];
      });


    var trainedSubscripts = resourceNodeGroups
      .append("text")
      .filter(function (d) {
        return d.id != "G";
      })
      .attr("text-anchor", "middle")
      .attr("dy", "-1em")
      .attr("dx", function (d) {
        return dx[d.id] - 2;
      })
      .attr("font-size", "15px")
      .attr("vector-effect", "non-scaling-stroke")
      .attr("style", "fill: #F0F0F0;")
      .text(function (d) {
        return d.id;
      });


    return textLabels;
  }


  updateNodes(newMetrics) {

    const color1 = "#60D937";
    const color2 = "#FFF44F";
    const color3 = "#FF2400";

    var waitingTimes = getCumulativeWaitingTimesPerGroup(newMetrics, this.resourceGroups);
    
    var maxWaitingTime = waitingTimes.maxThreshold;
    
    const colorScale = d3.scaleLinear()
    .domain([0, maxWaitingTime / 2, maxWaitingTime]) // Points in the scale
    .range([color1, color2, color3]) // Colors corresponding to the points
    .interpolate(d3.interpolateRgb); // Interpolation method

    
    const sizeScale = d3.scaleLinear()
    .domain([0, maxWaitingTime]) // Points in the scale
    .range([10, 20]) // Colors corresponding to the points
    

    // Change the color of the nodes
    this.notificationNodes
    .transition()
    .duration(200)
    .ease(d3.easeLinear)
    .attr("r", function (d) {
      var val = newMetrics.waitingTime[d.id];
      var size = sizeScale(val);
      return size;
    })
    .style("fill", function (d) {
      var val = newMetrics.waitingTime[d.id];
      var color = colorScale(val);
      return color;
    });
  }


  getIDResourceToGroupMap(resourceGroups) {
    var keys = Object.keys(resourceGroups);

    var idToResource = {};
    for (let groupID of keys) {
      idToResource[groupID] = resourceGroups[groupID];
    }

    // idToResource["Input"] = { name: "Input", color: "black", id: "Input" };
    // idToResource["Output"] = { name: "Output", color: "black", id: "Output" };

    return idToResource;
  }
}

module.exports = { NodeVisualiser };